import type { RendererAppearance } from '@atlaskit/renderer/types';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ContentBodyType } from '../__types__/index.ts';
import type { PageContentRendererFabricProps } from './PageContentRendererFabricProps.ts';

export const PageContentRendererFabric: LoadableType<PageContentRendererFabricProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-PageContentRendererFabric" */ './PageContentRendererFabric.tsx'
				)
			).PageContentRendererFabric,
		name: 'PageContentRendererFabric',
	});

export const PageContentRendererTiny: LoadableType<{
	contentAppearance: RendererAppearance;
	contentBody: ContentBodyType;
	contentId: string;
	spaceKey?: string | null;
	getLegacyContentExtensions?: () => any;
	markerRefs: string[];
	queryHash?: string;
	renderPerformanceMetrics: (props: any) => (...args: any) => JSX.Element;
	revision: string;
	setRootEl: (el: HTMLDivElement | null) => void;
	lastModifiedDate?: string | null;
}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageContentRendererTiny" */ './PageContentRendererTiny.tsx'
			)
		).PageContentRendererTiny,
	name: 'PageContentRendererTiny',
});
